import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";
import Calendar from "react-calendar";

import * as componentTypes from "../../../../../constants/componentTypes";
import * as navigationActions from "../../../../../actions/navigationActions";
import * as actions from "../../../../../actions/intergammaOrderActions";

class DatePickerModal extends Component {
    changeDate = (date) => {
        if (this.props.params === "from") {
            let newDate = new Date(date.setHours(0, 0, 0));
            this.props.dispatchChangeDateAction(newDate, this.props.to);
        }
        if (this.props.params === "to") {
            let newDate = new Date(date.setHours(23, 59, 59));
            this.props.dispatchChangeDateAction(this.props.from, newDate);
        }
    };

    getDatePicker = () => {
        let today = new Date();
        let minDay = new Date(2019, 0, 1);

        if (this.props.params === "from") {
            return (
                <Calendar
                    onClickDay={(date) => {
                        this.changeDate(date);
                    }}
                    maxDate={this.props.to === null ? today : this.props.to}
                    minDate={minDay}
                    value={this.props.from === null ? today : this.props.from}
                    locale={this.props.language}
                    minDetail="year"
                />
            );
        }

        if (this.props.params === "to") {
            return (
                <Calendar
                    onClickDay={(date) => {
                        this.changeDate(date);
                    }}
                    maxDate={today}
                    minDate={this.props.from === null ? minDay : this.props.from}
                    value={this.props.to === null ? today : this.props.to}
                    locale={this.props.language}
                    minDetail="year"
                />
            );
        }

        return "";
    };

    handleOkButton = () => {
        this.props.dispatchCloseDatePickerModalAction();
        this.props.dispatchChangeDateAction(this.props.from, this.props.to);
    };

    render() {
        return (
            <div id="modal" className="default-modal">
                <div className="modal-content intergamma-calendar">
                    <div className="col-xs-12">{this.getDatePicker()}</div>
                    <div className="modal-footer">
                        <div className="col-xs-12 text-right">
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleOkButton}>
                                <span className="glyphicon glyphicon-menu-right" />
                                <Translate value="general.ok" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        from: store.intergammaOrder.from,
        to: store.intergammaOrder.to,
        language: store.settings.locale
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseDatePickerModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.INTERGAMA_DATE_PICKER_MODAL));
        },
        dispatchChangeDateAction: (from, to) => {
            dispatch(actions.changeDate(from, to));
        }
    };
};

export default DatePickerModal = connect(mapStoreToProps, mapDispatchToProps)(DatePickerModal);
